import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./auth/authReducer";
import { queueReducer } from "./queue/queueReducer";
import { classesReducer } from "./classes/classesReducer";
import { registrationReducer } from "./registration/registrationReducer";
import { financialReducer } from "./financial/financialReducer";

const appReducer = combineReducers({
    auth: authReducer,
    queue: queueReducer,
    classes: classesReducer,
    registration: registrationReducer,
    financial: financialReducer,
});

/**
 * Wrap appReducer: trên AUTH_LOGOUT reset TOÀN BỘ Redux state về initial.
 * Tránh stale data từ session trước (vd queue.position, registration list của SV cũ)
 * lộ khi user logout rồi login lại (đặc biệt nếu đăng nhập SV khác).
 *
 * Pass undefined cho từng slice → mỗi reducer return initial state mặc định của nó.
 *
 * Cast `any` cho action vì combineReducers expect union strict các IXxxActions, nhưng wrapper
 * chỉ cần peek `action.type` — vẫn safe vì appReducer bên trong sẽ pattern-match như cũ.
 */
export const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
    if (action?.type === "AUTH_LOGOUT") {
        state = undefined;
    }
    return appReducer(state, action);
};

export type RootState = ReturnType<typeof appReducer>;
